<template>
  <main class="report page-main">
    <section class="page-heading-wrap">
      <h3 class="page-heading">{{ $t('consult.form.head') }}</h3>
    </section>

    <section>
      <validation-observer
        ref="observer"
        v-slot="{ invalid }"
        tag="div"
      >
        <form @submit.prevent="submit">
          <div class="support-form">
            <input-form
              id="subject"
              ref="subject"
              v-model="subject"
              :title="$t('consult.form.subject')"
              name="subject"
              :placeholder="$t('consult.form.subjectPlaceholder')"
              type="text"
              autocomplete="off"
              required="required"
              maxlength="50"
            />
            <input-form
              id="name"
              ref="name"
              v-model="name"
              :title="$t('consult.form.name')"
              name="name"
              :placeholder="$t('consult.form.namePlaceholder')"
              type="text"
              autocomplete="off"
              required="required"
              maxlength="50"
            />
            <input-form
              id="mail"
              ref="mail"
              v-model="mail"
              :title="$t('consult.form.email')"
              name="mail"
              :placeholder="$t('consult.form.emailPlaceholder')"
              type="email"
              autocomplete="off"
              required="required"
              maxlength="50"
            />
            <input-form
              id="textarea"
              ref="textarea"
              v-model="textarea"
              :title="$t('consult.form.detail')"
              name="textarea"
              :placeholder="$t('consult.form.detailPlaceholder')"
              type="textarea"
              autocomplete="off"
              required="required"
              maxlength="500"
            />
          </div>

          <div class="support-agree">
            <!--            <div class="agree-check-all">-->
            <!--              <check-box-->
            <!--                id="all"-->
            <!--                v-model="agreeAll"-->
            <!--                text="전체 동의합니다."-->
            <!--                name="agree-all"-->
            <!--                @input="onChangeAgreeAll($event)"-->
            <!--              />-->
            <!--            </div>-->

            <div class="agree-wrap">
              <div class="agree-title">{{ $t('consult.form.privateTitle') }}</div>
              <div class="agree-content">
                <div class="agree-check">
                  <check-box
                    id="private"
                    ref="private"
                    v-model="agreePrivate"
                    :text="$t('consult.form.private')"
                    name="agree-private"
                    required="required"
                  />
                </div>
                <html-view class="agree-term" :value="$t('consult.form.privateValue')" />
              </div>
            </div>
          </div>

          <div class="support-btn">
            <button type="submit" class="btn btn-fill btn-wide" :disabled="invalid">{{ $t('consult.form.submit') }}</button>
          </div>
        </form>
      </validation-observer>
    </section>
  </main>
</template>
<script>
import supportForm from '@/mixins/supportForm'
// import defendPath from '@/mixins/defendPath'

export default {
  mixins: [supportForm],
  watch: {
    agreePrivate (v) {
      this.agreeAll = v
    }
  },
  methods: {
    submit () {
      this.saveQuestion({
        title: this.subject,
        name: this.name,
        email: this.mail,
        content: this.textarea,
        type: 'CONSULT'
      }, 'Consult', {
        locale: this.$route.params.locale
      })
    },
    onChangeAgreeAll (v) {
      if (v) {
        this.agreePrivate = true
        this.agreePrecautions = true
      } else {
        this.agreePrivate = false
        this.agreePrecautions = false
      }
    }
  }
}
</script>
